import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginUser } from "../services/operations/loginAPi";
import Cookies from "js-cookie";

const loginSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    logoutUser(state) {
      document.cookie = `authToken=; domain=katalisia.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      Cookies.remove('authToken');
      Cookies.remove('jwt_token');
      // document.cookie = `authToken=; domain=localhost; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
      state.isAuthenticated = false;
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logoutUser } = loginSlice.actions;
export default loginSlice.reducer;
